



































import Component from 'vue-class-component';
import Vue from 'vue';
import DataTableTemplate from '@/views/datatable/DataTableTemplate.vue';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {IDENTITY_SERVICE_INSTANCE} from '@/services/identity.service';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import {
  MY_COMPANY_CHANGED_LISTENER_SERVICE_INSTANCE
} from '@/views/pageskeleton/companychange/company-changed-listener.service';

@Component({
  components: {DataTableTemplate}
})
export default class CompanyChangeSearchTemplate extends Vue {

  loading: boolean = false;

  handleChange(event: { url: string }) {
    if (this.$store.state.companyChange.show) {
      this.$store.commit('hideCompanyChangeSearch');
    }
    this.loading = true;
    HTTP_SERVICE_INSTANCE.getAxios()
        .post<DisguiseDto.FTDefinitionDto>(event.url)
        .then(() => {
          IDENTITY_SERVICE_INSTANCE.refreshToken().then(() => {
            if (this.$router.currentRoute.fullPath !== '/welcome') {
              this.$router.push('/welcome');
            }
            this.loading = false;
            MY_COMPANY_CHANGED_LISTENER_SERVICE_INSTANCE.notifyMyCompanyChanged();
          }, (error) => {
            if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
              this.$store.commit('showSnack', {
                message: 'Wechseln der Firma fehlgeschlagen',
                color: 'error'
              });
            }
            this.loading = false;
          });
        });
  }

}
